import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { AppBar, Toolbar } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router'
import { Path } from 'core/Routes'

import { Row, Text } from 'ui'

import MobileProfile from 'components/Profile/MobileProfile'
import OrgsSearch from 'components/OrgsSearch'
import Tabs from 'pages/Home/Tabs'

import menu from 'assets/icons/menu_icon.svg'

const StyledAppBar = styled(AppBar)`
  box-shadow: none;
  background-color: var(--dark-back);
  color: var(--white);
`

const StyledTopbar = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
  color: var(--white);
  @media (max-width: 1081px) {
    flex-direction: column;
  }
`

const SRow = styled(Row)`
  height: 52px;
  width: 99%;
  box-sizing: border-box; // Ensure padding is included in width
`

const StyledTouchableOpacity = styled.div`
  display: flex;
  flex-direction: row;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 16px;
  background-color: #4F4F4F;
  cursor: pointer;
`

export const ToolIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path d="M6.09231 16.7747L5.75849 14.0908C5.57766 14.0209 5.40727 13.937 5.24732 13.8391C5.08736 13.7413 4.93088 13.6364 4.77787 13.5246L2.29505 14.573L0 10.589L2.149 8.95351C2.13509 8.85565 2.12814 8.7613 2.12814 8.67043V8.10429C2.12814 8.01342 2.13509 7.91906 2.149 7.82121L0 6.18568L2.29505 2.20168L4.77787 3.2501C4.93088 3.13827 5.09084 3.03343 5.25775 2.93558C5.42466 2.83772 5.59157 2.75385 5.75849 2.68395L6.09231 0H10.6824L11.0162 2.68395C11.1971 2.75385 11.3674 2.83772 11.5274 2.93558C11.6874 3.03343 11.8438 3.13827 11.9968 3.2501L14.4797 2.20168L16.7747 6.18568L14.6257 7.82121C14.6396 7.91906 14.6466 8.01342 14.6466 8.10429V8.67043C14.6466 8.7613 14.6327 8.85565 14.6049 8.95351L16.7539 10.589L14.4588 14.573L11.9968 13.5246C11.8438 13.6364 11.6839 13.7413 11.517 13.8391C11.3501 13.937 11.1831 14.0209 11.0162 14.0908L10.6824 16.7747H6.09231ZM8.42909 11.3229C9.23583 11.3229 9.92435 11.0364 10.4946 10.4632C11.0649 9.89009 11.3501 9.19814 11.3501 8.38736C11.3501 7.57658 11.0649 6.88462 10.4946 6.31149C9.92435 5.73835 9.23583 5.45178 8.42909 5.45178C7.60843 5.45178 6.91644 5.73835 6.35311 6.31149C5.78978 6.88462 5.50812 7.57658 5.50812 8.38736C5.50812 9.19814 5.78978 9.89009 6.35311 10.4632C6.91644 11.0364 7.60843 11.3229 8.42909 11.3229Z" fill="white" />
  </svg>
)

export const GlobeIcon = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path d="M10.1027 17.68C13.6325 17.68 16.5986 15.2664 17.4406 11.9995M10.1027 17.68C6.57287 17.68 3.60677 15.2664 2.76475 11.9995M10.1027 17.68C12.1951 17.68 13.8913 14.2875 13.8913 10.1027C13.8913 5.91787 12.1951 2.52539 10.1027 2.52539M10.1027 17.68C8.01028 17.68 6.31404 14.2875 6.31404 10.1027C6.31404 5.91787 8.01028 2.52539 10.1027 2.52539M10.1027 2.52539C12.9359 2.52539 15.406 4.08037 16.706 6.38346M10.1027 2.52539C7.26946 2.52539 4.79942 4.08037 3.49943 6.38346M16.706 6.38346C14.9351 7.91402 12.627 8.83981 10.1027 8.83981C7.57838 8.83981 5.27029 7.91402 3.49943 6.38346M16.706 6.38346C17.3261 7.48215 17.68 8.7511 17.68 10.1027C17.68 10.7577 17.5969 11.3933 17.4406 11.9995M17.4406 11.9995C15.2665 13.205 12.7648 13.8913 10.1027 13.8913C7.44062 13.8913 4.93887 13.205 2.76475 11.9995M2.76475 11.9995C2.6085 11.3933 2.52539 10.7577 2.52539 10.1027C2.52539 8.7511 2.87927 7.48215 3.49943 6.38346" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

interface Props { }

const MAppbar: FC<Props> = () => {
  const [open, setOpen] = useState(false)
  const onClose = () => setOpen(false)
  const history = useHistory()

  return (
    <StyledAppBar id='app-bar' position='static'>
      <StyledTopbar>
        <SRow justify='between' grow>
          <OrgsSearch />
          <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '8px' }}>
            <StyledTouchableOpacity onClick={() => setOpen((prev) => !prev)}>
              <ToolIcon />
              <Text size={14} weight={400} textcolor="#FFF">הגדרות</Text>
            </StyledTouchableOpacity>
            <StyledTouchableOpacity onClick={() => history.push(Path.COMMUNITY)}>
              <GlobeIcon />
              <Text size={14} weight={400} textcolor="#FFF">אתר הקהילה</Text>
            </StyledTouchableOpacity>
          </div>
        </SRow>
        <Row>
          <Tabs />
        </Row>
      </StyledTopbar>
      <MobileProfile open={open} onClose={onClose} />
    </StyledAppBar>
  )
}

export default observer(MAppbar)
